<template>
    <TopNav></TopNav>
		<h1>Bileşik Faiz Hesaplama</h1>
		<fieldset>
      <legend>Bileşik Faiz Hesaplama Aracı</legend>
      <label for="a">Anapara:</label> <input type="number" v-model.number="anapara" id="a" step="any" min="0"> ₺
      <br>
      <label for="b">Yıllık Faiz Oranı:</label> <input type="number" v-model.number="faizOrani" id="b" step="any" min="0"> %
      <br>
      <label for="b">Vade:</label> <input type="number" v-model.number="vade" id="b" step="any" min="0"> yıl
      <br><br>
      {{ formatliAnapara() }} ₺ olan anapara yıllık %{{ faizOrani }} faizle {{ vade }} yıl sonunda <span class="blue">{{ sonuc() }} ₺</span> olacaktır.
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "BilesikFaiz",
  data() {
    return {
      anapara: 2000,
      faizOrani: 25,
      vade: 2,
    }
  },
  components: {
    TopNav
  },
  methods: {
    sonuc: function () {
      let oran = (1 + this.faizOrani / 100);
      let sonuc = this.anapara *  Math.pow(oran, this.vade);
      let sonucNumber = Number(sonuc);
      const formatter = new Intl.NumberFormat('tr-TR', {
        maximumFractionDigits: 2
      });
      return formatter.format(sonucNumber);
    },
    formatliAnapara() {
      let anaparaNumber = Number(this.anapara);
      const formatter = new Intl.NumberFormat('tr-TR', {
        maximumFractionDigits: 2
      });
      return formatter.format(anaparaNumber);
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 145px;
}

input {
  width: 121px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
